document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("product-video");

  function isMobile() {
    return window.innerWidth <= 767;
  }

  // Mobile-only behavior
  if (video && isMobile()) {
    // Force required attributes
    video.controls = false;
    video.setAttribute("autoplay", true);
    video.setAttribute("muted", true);
    video.setAttribute("loop", true);
    video.setAttribute("playsinline", true);

    // Disable interaction completely
    video.style.pointerEvents = "none";
    video.style.userSelect = "none";
    video.style.webkitUserDrag = "none";

    // Hide media controls on mobile browsers
    const style = document.createElement("style");
    style.textContent = `
      #product-video::-webkit-media-controls,
      #product-video::-webkit-media-controls-enclosure,
      #product-video::-webkit-media-controls-panel {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }
});
